export enum ListMode {
  LIST = 'list',
  DATE_RANGE = 'date_range',
}
